import React from 'react';
import './styles.css';
import { Link } from 'react-router-dom';
import { Row, Col } from 'antd';
import { DividerContainer, ItemList } from '@BUP/components';
import ConoceInstrumentos from '@BUP/assets/Images/Data/data_(1)_conoce-instrumentos.png';
import ActivaInstrumentos from '@BUP/assets/Images/Data/data_(2)_activa-instrumentos.png';
import RespondeDiagnostico from '@BUP/assets/Images/Data/data_(3)_responde-diagnostico.png';
import Seguimiento from '@BUP/assets/Images/Data/data_(4)_seguimiento.png';
import ImageData from '@BUP/assets/Images/Data/data-18.png';
import { useTranslation } from 'react-i18next';

const DataCounselorPage = () => {
  const [t] = useTranslation();
  return (
    <>
      <DividerContainer title="BRAVE UP! DATA" />

      <p className="welcome-paragraph">{t('pages.data.welcomeTextECE')}</p>

      <ItemList
        className="item-list"
        count="1"
        src={ConoceInstrumentos}
        title={<Link to="data/instruments">{t('pages.data.title1ECE')}</Link>}
        description={t('pages.data.description1ECE')}
        url={
          <Link className="itemList-link" to="data/instruments">
            {t('pages.data.linkTextHere')}
          </Link>
        }
        urlLink="data/instruments"
      />

      <ItemList
        count="2"
        src={ActivaInstrumentos}
        title={
          <Link to="data/active-instruments">{t('pages.data.title2ECE')}</Link>
        }
        description={t('pages.data.description2ECE')}
        url={
          <Link className="itemList-link" to="data/active-instruments">
            {t('pages.data.linkTextHere')}
          </Link>
        }
      />

      <ItemList
        count="3"
        src={RespondeDiagnostico}
        title={
          <Link className="itemList-link" to="data/confirm-survey">
            {t('pages.data.title3ECE')}
          </Link>
        }
        description={t('pages.data.description3ECE')}
        url={
          <Link className="itemList-link" to="data/confirm-survey">
            {t('pages.data.linkTextHere')}
          </Link>
        }
      />

      <ItemList
        count="4"
        src={Seguimiento}
        title={<Link to="data/tracking">{t('pages.data.title4ECE')}</Link>}
        description={t('pages.data.description4ECE')}
        url={
          <Link className="itemList-link" to="data/tracking">
            {t('pages.data.linkTextHere')}
          </Link>
        }
      />

      <Row justify="end">
        <Col span={12}>
          <img style={{ width: '100%' }} src={ImageData} alt="" />
        </Col>
      </Row>
    </>
  );
};

export default DataCounselorPage;
